export function compareMarkets(a, b) {
    return `${a.name}${a.id}`.localeCompare(`${b.name}${b.id}`, undefined, { numeric: true });
}
//# sourceMappingURL=compareMarkets.js.map